"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBTabs", {
  enumerable: true,
  get: function get() {
    return _SVBTabs.default;
  }
});
var _SVBTabs = _interopRequireDefault(require("./src/SVBTabs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }